module.exports = __webpack_public_path__ + "img/003.3e9167b3.jpg";